import React from "react";
import { Paper, Grid, Container, Typography } from "@mui/material";
import styled from "@mui/system/styled";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Tags from "./tags";
import CCLicence from "./cc";
import Contributers from "./contributers";
import FileInfo from "./fileinfo";
import DownloadItem from "./downloaditem";
import { imageFormatUrl, locales } from "../utils";
import { LocaleSelector } from "./localeselector";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const PageWrapper = styled("div")({
  height: "auto",
  position: "relative",
});

const BackWrapper = styled("div")({
  position: "relative",
  top: "15px",
  left: "0",
});

const ContributerWrapper = styled("div")`
  padding-bottom: 8px;
`;

const FileItemWrapper = styled("div")`
  text-align: left;
`;

const Img = styled("img")`
  max-width: 100%;
  margin: 15px 0;
`;

const isImage = (type) => type === "illustration" || type === "image";
const createMarkup = (html) => {
  return { __html: html };
};

export const FileItem = ({ item, nonce = null, loadFile = null }) => {
  const [downloads, setDownloads] = React.useState([]);
  const {
    tags,
    title,
    alt,
    media,
    license = null,
    audio_translation = null,
    contributers = [],
    localizations = [],
  } = item;

  if (!localizations.some((x) => x.locale === item.locale)) {
    localizations.push({ locale: item.locale });
  }

  const handleLocaleChange = (userLocale) => {
    const translatedItem = localizations.find((x) => x.locale === userLocale);
    /* const fileUrl = `/file/${translatedItem.id}`;
    router.push(fileUrl, fileUrl, { locale: userLocale }); */
    // window.location.hash = `fileItem=${translatedItem.id}`;
    if (loadFile) {
      loadFile(translatedItem.id);
    }
  };

  const handleDownload = async (fileItem, isAdudio = false, refId = null) => {
    setDownloads([...downloads, fileItem.id.toString()]);
    const fileTarget = {
      isAudioTranslation: isAdudio,
    };
    if (isAdudio) {
      fileTarget.ref = "audio_translation";
    } else {
      fileTarget.ref = fileItem._id.toString();
    }
    fileTarget.id = item._id.toString();
    if (refId) {
      fileTarget.refId = refId;
    }
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": nonce,
      },
      body: JSON.stringify({ file: fileTarget }),
    };

    await fetch("/?rest_route=/edupix_restapi/v1/addfile", options)
      .then((response) => response.json())
      .then((data) => {
        // TODO: handle errors
        // console.log("data: ", data);
        setDownloads([
          ...downloads.filter((f) => f !== fileItem.id.toString()),
        ]);
      });
  };

  let audioTrans = null;
  if (audio_translation) {
    audioTrans = {
      url: audio_translation.url,
      mime: "audio/wav",
    };
  }

  return (
    <PageWrapper>
      <Container fixed>
        <BackWrapper>
          <Button onClick={() => history.go(-1)} startIcon={<ArrowBack />}>
            Back
          </Button>
        </BackWrapper>
        <Grid mt={5} container spacing={2}>
          <Grid item xs={8}>
            <Item>
              <Typography
                variant="h5"
                component="h2"
                dangerouslySetInnerHTML={createMarkup(title)}
              />
              {item.contenttype && isImage(item.contenttype) && (
                <Img
                  src={imageFormatUrl(media[0], "large")}
                  loading="lazy"
                  alt={alt && alt !== "" ? alt : title}
                />
              )}
              {audioTrans && (
                <div>
                  <audio src={audioTrans.url} controls>
                    <source src={audioTrans.url} type={audioTrans.mime} />
                  </audio>
                </div>
              )}
              {tags && tags.length && <Tags tags={tags} />}
              {license && <CCLicence license={license} />}
            </Item>
          </Grid>
          <Grid item xs={4}>
            <Item>
              {item && (
                <FileItemWrapper>
                  <Typography variant="h4" component="h1">
                    {item.author}
                  </Typography>
                  <FileInfo
                    fileTitle={title}
                    fileType={media[0].mime}
                    fileRef={item.ref}
                  />
                  {contributers && contributers.length > 0 && (
                    <ContributerWrapper>
                      <Contributers contributers={item.contributers} />
                    </ContributerWrapper>
                  )}
                  <DownloadItem
                    fileItem={media[0]}
                    buttonText="Add file to library"
                    // onDownload={handleDownload}
                    onDownload={(fileItem) =>
                      handleDownload(media[0], false, item._id.toString())
                    }
                    isDownloading={downloads.includes(
                      item.media[0]._id.toString()
                    )}
                  />
                </FileItemWrapper>
              )}
              {audio_translation && (
                <FileItemWrapper>
                  <Typography variant="h4" component="h1">
                    {item.author}
                  </Typography>
                  <FileInfo fileTitle={item.title} fileType="audio/wav" />
                  <ContributerWrapper>
                    <Contributers
                      contributers={audio_translation.contributers}
                    />
                  </ContributerWrapper>
                  <DownloadItem
                    fileItem={{
                      ...audio_translation,
                      id: `${item.id}`,
                      name: title,
                      mime: "audio/wav",
                      ext: "wav",
                    }}
                    buttonText="Add file to library"
                    onDownload={(audioItem) => handleDownload(audioItem, true)}
                    isDownloading={downloads.includes(`${item._id.toString()}`)}
                  />
                </FileItemWrapper>
              )}
            </Item>
            {localizations && localizations.length > 1 && (
              <div style={{ textAlign: "center" }}>
                <br />
                Also available in other languages:
                <LocaleSelector
                  color="rgba(0, 0, 0, 0.65)"
                  onLocaleChange={handleLocaleChange}
                  options={localizations
                    .filter((x) => locales[x.locale])
                    .reduce((map, obj) => {
                      map[obj.locale] = locales[obj.locale];
                      return map;
                    }, {})}
                  locale={item.locale}
                />
              </div>
            )}
          </Grid>
        </Grid>
      </Container>
    </PageWrapper>
  );
};
